import urls from '../constants/urls.js';
import { fetch } from 'domain-task';
import BaseService from './baseService';

class TrackService {
    static getFeaturedTracks () {    
        return BaseService.getAndReturn('/TrackOfTheWeek', BaseService.returnAssignedArray, 'Unable to fetch featured tracks', true);
    } 

    static getTrack(trackID) {    
        return BaseService.getAndReturn(`/Tracks/${trackID}`, BaseService.returnAssignedObject, 'Unable to fetch track', true);
    }

    static getCharts() {    
        return BaseService.getAndReturn('/Chart/Music', BaseService.returnAssignedArray, 'Unable to fetch charts', true);
    }

    static playTrack(trackID, currentProfileID) {    
        return BaseService.getAndReturn(`/Tracks/${trackID}/Stream?currentProfileID=${currentProfileID}`, BaseService.returnAssignedObject, 'Unable to play track', true);
    }   

    static reportBrokenTrack(trackID) {    
        return BaseService.postAndReturn(`/Tracks/${trackID}/ReportBroken`, {}, BaseService.returnAssignedObject, null, true);
    }   
    
    static increaseRating(trackID, currentProfileID) {
        return BaseService.postAndReturn(`/Tracks/${trackID}/Ratings?currentProfileID=${currentProfileID}`, {}, BaseService.returnAssignedObject, 'Unable to rate track', true);
    }

    static decreaseRating(trackID, currentProfileID) {
        return BaseService.deleteAndReturn(`/Tracks/${trackID}/Ratings?currentProfileID=${currentProfileID}`, {}, BaseService.returnAssignedObject, 'Unable to remove track rating', true);
    }
}
export default TrackService;